<script setup>
import { ref, onMounted, onUnmounted } from 'vue'
import { eventBus, closeOtherMenus } from '@/utils/eventBus'

const props = defineProps({
	color: {
		type: String,
		default: 'blue',
	},
	full: {
		type: Boolean,
		default: false,
	},
	right: {
		type: Boolean,
		default: false,
	},
	small: {
		type: Boolean,
		default: false,
	},
	class: {
		type: String,
		default: '',
	},
})

const isOpen = ref(false)

const toggleMenu = () => {
	if (!isOpen.value) {
		closeOtherMenus()
	}
	isOpen.value = !isOpen.value
}

const closeMenu = (event) => {
	if (!event.target.closest('.button-menu')) {
		isOpen.value = false
	}
}

onMounted(() => {
	document.addEventListener('click', closeMenu)
	eventBus.on('close-menus', () => {
		isOpen.value = false
	})
})

onUnmounted(() => {
	document.removeEventListener('click', closeMenu)
	eventBus.off('close-menus')
})
</script>

<template>
	<div class="button-menu" :class="{ open: isOpen }">
		<div :class="['button', color, { full: full, small: small }, props.class]" @click="toggleMenu">
			<slot name="button-content"></slot>
		</div>
		<ul class="button-menu-list" :class="{ right: right }">
			<slot></slot>
		</ul>
	</div>
</template>
